<script setup>
const props = defineProps({
    idsolicitacao: {
        type: [String, Number],
        default: null
    },
    tipo: {
        type: String,
    },
    tutorial: {
        type: Boolean,
    }
});

const emit = defineEmits(['iniciarTour']);

const handleIniciarTour = () => {
    emit('iniciarTour');
};

</script>
<template>
    <ReturnTrail action="historicoAnterior" :icon="true" />

    <div class="w-full flex justify-content-between flex-column gap-5 lg:flex-row">
        <div class="flex flex-column gap-2 align-items-baseline">
            <div class="flex align-items-center gap-3">
                <h1 class="text-900 m-0 text-3xl md:text-4xl">
                    {{ props.idsolicitacao ? 'Editar Solicitação de ' + props.tipo : 'Nova Solicitação de ' + props.tipo }}
                </h1>
            </div>

            <div class="flex flex-row gap-2 flex-wrap lg:gap-4">
                <p class="text-600 font-normal m-0 text-sm">
                    {{ props.idsolicitacao ? 'Edite os dados para atualizar a solicitação.' : 'Preencha os dados para cadastrar uma nova solicitação.' }}
                </p>
            </div>


            <Button v-if="!props.idsolicitacao && props.tutorial" @click="handleIniciarTour" icon="pi pi-compass" label="Fazer tutorial"
                class="mt-3" size="small" severity="secondary" outlined rounded />
        </div>
    </div>
</template>
